// extracted by mini-css-extract-plugin
module.exports = {"desc":"about_desc_1ed17","desc1":"about_desc1_2lKvn","loc":"about_loc_5_ItM","loc1":"about_loc1_YU_aG","pic":"about_pic_CFtCz","w4":"about_w4_3KsY8","right":"about_right_1xa2X"};